import { create } from 'zustand';

interface SidebarState {
  collapsed: boolean;
  /** The state before an auto-collapse (so we can restore it). `null` means no auto-collapse is active. */
  previousCollapsed: boolean | null;
  setCollapsed: (collapsed: boolean) => void;
  /** Auto-collapse the sidebar, remembering the previous state for restoration. */
  autoCollapse: () => void;
  /** Restore the sidebar to whatever state it had before the last autoCollapse. */
  restoreCollapsed: () => void;
}

export const useSidebarStore = create<SidebarState>((set) => ({
  collapsed: false,
  previousCollapsed: null,
  setCollapsed: (collapsed) => set({ collapsed, previousCollapsed: null }),
  autoCollapse: () =>
    set((state) => {
      if (state.collapsed) return state; // already collapsed, nothing to remember
      return { collapsed: true, previousCollapsed: state.collapsed };
    }),
  restoreCollapsed: () =>
    set((state) => {
      if (state.previousCollapsed === null) return state; // nothing to restore
      return { collapsed: state.previousCollapsed, previousCollapsed: null };
    }),
}));
